// extracted by mini-css-extract-plugin
export var columnList = "_hl-0";